import { HelpTooltip } from '@front/components/HelpTooltip';
import { RadioGroup, RadioItem, Textarea, TextField } from '@plaidev/sour-react';
import type { ReactElement } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { DomainV2 } from 'troppus-common/domain';

import { loadModeOptions } from '../constants';
import type { FormValues } from '../types';

import ImportTableDefinition = DomainV2.Import.ImportTableDefinition;

type ConfigureBasicSectionProps = {
  selectedSourceSystemName: string;
};

export function ConfigureBasicSection({ selectedSourceSystemName }: ConfigureBasicSectionProps): ReactElement {
  const { control } = useFormContext<FormValues>();

  return (
    <section className="flex flex-col gap-4">
      <h2 className="text-sm font-semibold text-default">基本設定</h2>
      <div className="flex flex-col gap-2">
        <span className="text-sm font-medium text-default">ソースシステム</span>
        <p className="text-sm text-default">{selectedSourceSystemName}</p>
      </div>
      <div className="flex flex-col gap-2">
        <span className="text-sm font-medium text-default">
          表示名<span className="text-negative">*</span>
        </span>
        <Controller
          control={control}
          name="displayName"
          rules={{ validate: (v) => v.trim().length > 0 || '表示名を入力してください' }}
          render={({ field }) => <TextField variant="contained" value={field.value} onChange={field.onChange} placeholder="例: 受注CSV" />}
        />
      </div>
      <div className="flex flex-col gap-2">
        <span className="text-sm font-medium text-default">説明（任意）</span>
        <Controller
          control={control}
          name="description"
          render={({ field }) => <Textarea className="[&>textarea]:w-full" rows={3} value={field.value} onChange={field.onChange} />}
        />
      </div>
      <div className="flex flex-col gap-2">
        <span className="text-sm font-medium text-default">取込モード</span>
        <Controller
          control={control}
          name="loadMode"
          render={({ field }) => (
            <RadioGroup value={field.value} onValueChange={(v) => field.onChange(v as ImportTableDefinition.LoadMode)}>
              {loadModeOptions.map((o) => (
                <div key={o.value} className="flex items-center gap-2">
                  <RadioItem value={o.value} label={o.label} />
                  <HelpTooltip
                    content="CSV の内容で既存データを置き換えます。ファイルに含まれない既存データは削除されます。"
                    side="right"
                    ariaLabel="洗い替えの説明"
                  />
                </div>
              ))}
            </RadioGroup>
          )}
        />
      </div>
      <input type="hidden" name="importMethod" value="Upload" readOnly aria-hidden />
    </section>
  );
}
